import EBarEthicsCTA from './EBarEthicsCTA';

export default EBarEthicsCTA;
